import React, { useState } from "react";
import Nav from "../Components/Nav";
import { AnimatePresence, motion } from "framer-motion";
import ProjectList from "../Components/ProjectList";
import styled from "styled-components";
import Footer from "../Components/Footer";

function Work() {
  const [click, setclick] = useState(true);

  const handleClick = () => {
    setclick(false);
  };

  const container = {
    hidden: { opacity: 1, scale: 1 },
    visible: {
      transition: {
        delayChildren: 1,
        staggerChildren: 0.1,
      },
    },
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    },
  };

  const project = [
    {
      url: "https://github.com/",
      name: "spotify clone",
    },
    {
      url: "https://github.com/",
      name: "booking.com",
    },
    {
      url: "https://github.com/",
      name: "oyo clone",
    },
    {
      url: "https://github.com/",
      name: "olx clone",
    },
    {
      url: "https://github.com/",
      name: "Food delivery app",
    },
  ];

  return (
    <>
      <Nav />
      <AnimatePresence initial={true} mode="wait">
        <motion.div
          className="page2"
          animate={{
            left: "auto",
            right: 0,
            width: "0",
            transition: { duration: 0.5 },
          }}
        ></motion.div>
      </AnimatePresence>
      {click && (
        <motion.div
          className="page"
          key="index"
          exit={{ width: "100%", transition: { duration: 1 } }}
        ></motion.div>
      )}
      <>
        <div>
          <Banner>
            <Wrapper>
              <Title
                initial={{ y: 100 }}
                animate={{ y: 0 }}
                transition={{ transition: 1, delay: 2 }}
              >
                My Works.
              </Title>
            </Wrapper>
          </Banner>
        </div>
        <ProjectList setclick={setclick} />

        <motion.div
          style={{ maxWidth: "1200px", width: "100%", margin: "80px auto", padding: "0 20px" }}
          key={"note"}
          exit={{ opacity: 0 }}
        >
          <NoteText
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            Some projects have been omitted as they were either confidential
            or have since been replaced by newer work.
          </NoteText>

        </motion.div>
        <motion.div
          style={{ maxWidth: "1200px", width: "100%", margin: "80px auto", padding: "0 20px" }}
          key={"github"}
          exit={{ opacity: 0 }}
        >
          <motion.div
            style={{
              overflow: "hidden",
              position: "relative",
              width: "fit-content",
            }}
          >
            <RevealBar
              initial={{
                width: "0%",
                top: 0,
                height: "100%",
                position: "absolute",
              }}
              whileInView={{ width: "100%", x: ["0%", "0%", "0%", "100%"] }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
            />
            <GithubTitle
              initial={{ y: "100%" }}
              whileInView={{ y: 0 }}
              transition={{ delay: 1 }}
              viewport={{ once: true }}
            >
              Github Projects
            </GithubTitle>
          </motion.div>
          <SectionDesc
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.6, duration: 0.8 }}
          >
            Side projects I build to sharpen skills, explore new technologies,
            and stay curious. Browse the full list on my GitHub profile.
          </SectionDesc>

          <motion.ul
            initial="hidden"
            variants={container}
            animate="visible"
            viewport={{ once: true }}
          >
            <List key="spotify" variants={item}>
              Spotify Clone
            </List>
            <List key="booking" variants={item}>
              Booking.com Clone
            </List>
            <List key="oyo" variants={item}>
              Oyo Clone
            </List>
            <List key="olx" variants={item}>
              OLX Clone
            </List>
            <List key="netflix" variants={item}>
              Netflix Clone
            </List>
          </motion.ul>
        </motion.div>
        <motion.div
          style={{ maxWidth: "1200px", margin: "0 auto 80px", padding: "0 20px", width: "100%" }}
        >
          <SectionDesc
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.6, duration: 0.8 }}
          >
            These are projects I built in my spare time to keep learning.
          </SectionDesc>
        </motion.div>
        <Footer />
      </>
    </>
  );
}

export default Work;

const Banner = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  flex-direction: column;
  background: url(/Images/WorkBg.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 600px;
  padding: 0 20px;
  transition: background-color 0.3s ease, color 0.3s ease;

  @media (max-width: 768px) {
    background-size: 300px;
    height: 60vh;
    min-height: 300px;
  }
`;

const Title = styled(motion.h2)`
  text-align: center;
  color: var(--text);
  font-size: 100px;
  line-height: 110px;

  @media (max-width: 768px) {
    font-size: 52px;
    line-height: 60px;
  }
  @media (max-width: 400px) {
    font-size: 38px;
    line-height: 46px;
  }
`;
const Wrapper = styled(motion.div)`
  overflow: hidden;
  position: relative;
`;

const List = styled(motion.li)`
  font-size: 24px;
  line-height: 34px;
  margin-bottom: 20px;
  overflow: hidden;
  position: relative;
  width: fit-content;

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 28px;
  }
`;

const NoteText = styled(motion.p)`
  margin: 30px 0;
  font-size: 16px;
  line-height: 28px;
  color: var(--text-5);

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 24px;
  }
`;

const GithubTitle = styled(motion.h2)`
  font-size: 45px;
  line-height: 52px;
  letter-spacing: -0.5px;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 36px;
    letter-spacing: -0.3px;
  }
`;

const SectionDesc = styled(motion.p)`
  margin: 28px 0;
  font-size: 20px;
  line-height: 34px;
  color: var(--text-3);

  @media (max-width: 768px) {
    font-size: 15px;
    line-height: 26px;
  }
`;

const RevealBar = styled(motion.div)`
  background: var(--overlay);
  transition: background 0.3s ease;
`;
